import {INTERVIEW_TYPES, TRANSLATION, Yup, MANAGE_ASSESSMENT} from '@/imports-files/pages/clients/jobs/automations';
import moment from 'moment';
import {isCustomLink} from '@/actions/components/add-interview';

export const URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;

export function manualInitialValues(values, action, job_application_id){

if (action == 'new')
{
    return {
      interview_type_id: '',
      default_location: '',
      place_id: '',
      job_application_id: job_application_id,
      date_range: true,
      children_attributes: [],
      primary: false,
    // Video QA Interview
      language: 'English',
      video_link: '',
      questions_attributes: [{question: '', description: '', attempts: 2, answer_time: 30, _destroy: false}],
      job_stage_attributes: {automation: false},
      practise_screen: false,
      expires: null,
      videoqa: {
        member_emails: [],
        member_initials: []
      }
    // Video QA Interview
    }
  }
  else if(action == 'edit'){
      values.default_location = ''
      values.place_id = ''
      values.date_range = true
      values.children_attributes.map((x) => {
        x.date = '',
        x.starttime = '',
        x.endtime = '',
        x.start_time = x.start_time || ''
        x.end_time = x.end_time || '',
        x.integration_id = x.integration_id || '',
        x.location = x.location || '',
        x.place_id = x.place_id,
        x.meeting_link = x.meeting_link || ''
        return x;
      })

     values.language = values.language || 'English';
     values.video_link = values.video_link || '';
     values.questions_attributes = values.questions_attributes || [{question: '', description: '', attempts: 2, answer_time: 30, _destroy: false}];
     values.job_stage_attributes = values.job_stage_attributes || {automation: false};
     values.practise_screen = values.practise_screen || false;
     values.expires = values.expires || null;
     values.videoqa = {
        member_emails: [],
        member_initials: []
      }
     return values;
  }
};

export function validationManualform(addType, current_interview_type, sendInterview, platforms, validationData)
{
  const CONSTANTS = {errors:{
                                          minimum: 'Minimum $number',
                                          maximum: 'Maximum $number'
                                    }
                  }

  return Yup.object().shape({
    interview_type_id: Yup.string().required(TRANSLATION('common:errors:required')),
    place_id: Yup.string().nullable(true),
    default_location: Yup.string().when([],{
      is: () => {
        return current_interview_type == INTERVIEW_TYPES.FACE2FACE
      },
      then: Yup.string().required(TRANSLATION('common:errors:required')).test("validLocation", "Invalid address, Please select from the dropdown", function (value) {
          return this.parent.place_id && this.parent.place_id.length > 0
        })
    })
    }).when((values, schema) => {     if ([INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type))
                                      {
                                        return schema.shape({children_attributes: Yup.array().of(
                                                                          Yup.object().shape({
                                                                          _destroy: Yup.boolean(),
                                                                          date: Yup.string().when("_destroy", {
                                                                            is: (_destroy) => {
                                                                              return addType == "time" && !_destroy && sendInterview
                                                                            },
                                                                            then: Yup.string().nullable().required(TRANSLATION('common:errors:required'))
                                                                          }),
                                                                          starttime: Yup.string().when("_destroy", {
                                                                            is: (_destroy) => {
                                                                              return addType == "time" && !_destroy && sendInterview
                                                                            },
                                                                            then: Yup.string().required(TRANSLATION('common:errors:required'))
                                                                                  .test("is-correct", "Please select valid start time.", function(value) {
                                                                                        return isCorrectTime(value)
                                                                                  })
                                                                          }),
                                                                          endtime:   Yup.string().when("_destroy", {
                                                                            is: (_destroy) => { return addType == "time" && !_destroy && sendInterview },
                                                                            then: Yup.string().required(TRANSLATION('common:errors:required')).test("is-greater", "End time should be greater than start time", function(value) {
                                                                              let starttime = this.parent.starttime
                                                                              return isValidTime(starttime, value)
                                                                            })
                                                                            .test("is-equal", "Start and end times can not be equal. Please select valid times.", function(value) {
                                                                               let starttime = this.parent.starttime;
                                                                                return isEqualTime(starttime, value)
                                                                            })
                                                                          }),
                                                                          member_ids: Yup.array().when("_destroy",{
                                                                              is: (_destroy) => { return !_destroy },
                                                                              then: Yup.array().min(1, TRANSLATION('common:errors:member_required'))
                                                                            }),
                                                                          // location: Yup.string().when("_destroy",{
                                                                          // is: (_destroy) => {
                                                                          //   return current_interview_type == INTERVIEW_TYPES.FACE2FACE && !_destroy
                                                                          // },
                                                                          // then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
                                                                          // }),
                                                                          duration: Yup.string().when("_destroy",{
                                                                              is: (_destroy) => { return !_destroy},
                                                                              then: Yup.string().required(TRANSLATION('common:errors:required'))
                                                                            }),
                                                                          integration_id: Yup.string().when("_destroy",{
                                                                          is: (_destroy) => {
                                                                            return current_interview_type == INTERVIEW_TYPES.VIDEO && !_destroy
                                                                          },
                                                                          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
                                                                        }),
                                                                          meeting_link: Yup.string().when(["_destroy", "integration_id"],{
                                                                          is: (_destroy, integration_id) => {
                                                                            return current_interview_type == INTERVIEW_TYPES.VIDEO && !_destroy && (!isCustomLink(platforms, integration_id))
                                                                          },
                                                                          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true).matches(URL_FORMAT, 'Meeting link is invalid.'),
                                                                        }),
                                                                          })
                                                                          )
                                                            })
                                      }
                                      else if([INTERVIEW_TYPES.VIDEOQA].includes(current_interview_type))
                                      {
                                        return schema.shape({
                                                                language: Yup.string().required(TRANSLATION('common:errors:required')),
                                                                intro_video: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url'),
                                                                video_link: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url'),
                                                                questions_attributes: Yup.array(
                                                                                      Yup.object().shape({
                                                                                      question: Yup.string().max(300, 'Question must be at most 300 characters').required(TRANSLATION('common:errors:required')),
                                                                                      description: Yup.string().max(300, 'Description must be at most 300 characters'),
                                                                                      answer_time: Yup.number().required(TRANSLATION('common:errors:required')).min(30,CONSTANTS.errors.minimum.replace('$number', 30).replace('$data', 'secs')).max(120, CONSTANTS.errors.maximum.replace('$number', 120).replace('$data', 'secs')).nullable(true),
                                                                                      attempts: Yup.number().required(TRANSLATION('common:errors:required')).min(1, CONSTANTS.errors.minimum.replace('$number', 1).replace('$data', 'attempt')).max(3, CONSTANTS.errors.maximum.replace('$number', 3).replace('$data', 'attempts')).nullable(true)
                                                                                  })),
                                                                expires: Yup.number().required(TRANSLATION('common:errors:required')).min(1, CONSTANTS.errors.minimum.replace('$number', 1)).max(30, CONSTANTS.errors.maximum.replace('$number', 30)).nullable(true)
                                                          })
                                      }
                                      else if([INTERVIEW_TYPES.TECHTEST].includes(current_interview_type)){
                                        return schema.shape({
        job_test_detail_attributes: Yup.object({
          test_id: Yup.string().required("Invalid test"),
          days_to_expire: Yup.string().required(TRANSLATION('common:errors:required')),
          test_type: Yup.string(),
          assessment: Yup.object()
          .shape({
            ...((validationData.type == 'Assessment') && (validationData.test_id.toString() == 'upload_new_test') ? {
              name: Yup.string().required(TRANSLATION('common:errors:required')),
              file_type: Yup.string().required(TRANSLATION('common:errors:required')),
              link: Yup.string().when("file_type", {
                is: (file_type) => file_type == 'link',
                then: Yup.string().matches(URL_FORMAT, 'Assessment link is invalid.'),
                otherwise: Yup.string().notRequired()
              }),
              filename: Yup.string().when("file_type", {
                is: (file_type) => file_type == 'file',
                then: Yup.string(),
                otherwise: Yup.string().notRequired()
              }),
              filesize: Yup.string().when("file_type", {
                is: (file_type) => file_type == 'file',
                then: Yup.string().test("is-greater", "Max. allowed file size 10 MB.", function(value) {
                  let currentFileSize = parseInt(value) || 0
                  return currentFileSize < MANAGE_ASSESSMENT.file_size
                }),
                otherwise: Yup.string().notRequired()
              }),
            } : {
            }),
          }),
        }),
      })
                                      }
                                                                                                 })}


    // children_attributes: Yup.array().of(
    //   Yup.object().shape({
    //   _destroy: Yup.boolean(),
    //   start_time: Yup.string().when("_destroy", {
    //     is: (_destroy) => {
    //      return addType == "time" && !_destroy && sendInterview
    //    },
    //     then: Yup.string().required(TRANSLATION('common:errors:required'))
    //   }),
    //   end_time:   Yup.string().when("_destroy", {
    //     is: (_destroy) => { return addType == "time" && !_destroy && sendInterview },
    //     then: Yup.string().required(TRANSLATION('common:errors:required')).test("is-greater", "end time should be greater with same date", function(value) {
    //       let start_time = this.parent.start_time
    //       return moment(moment(value).format("YYYY/MM/DD h:mm a")).isAfter( moment(start_time).format("YYYY/MM/DD h:mm a")) && moment( moment(value).format("YYYY/MM/DD")).isSame(moment(start_time).format("YYYY/MM/DD"))
    //     })
    //   }),
    //   member_ids: Yup.array().when("_destroy",{
    //       is: (_destroy) => { return !_destroy },
    //       then: Yup.array().min(1, TRANSLATION('common:errors:member_required'))
    //     }),
    //   location: Yup.string().when("_destroy",{
    //   is: (_destroy) => {
    //     return current_interview_type == INTERVIEW_TYPES.FACE2FACE && !_destroy
    //   },
    //   then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
    //   }),
    //   duration: Yup.string().when("_destroy",{
    //       is: (_destroy) => { return !_destroy},
    //       then: Yup.string().required(TRANSLATION('common:errors:required'))
    //     }),
    //   integration_id: Yup.string().when("_destroy",{
    //   is: (_destroy) => {
    //     return current_interview_type == INTERVIEW_TYPES.VIDEO && !_destroy
    //   },
    //   then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
    // }),
    // })
    // )

  export function isValidTime(start_time, end_time){
    let start_int = parseInt(start_time.replace(':', '')) 
    let end_int = parseInt(end_time.replace(':', ''))
    if(start_time.includes('-') || end_time.includes('-'))
      return true 
    return start_int <= end_int 
  }

  export function isEqualTime(start_time, end_time){
    let start_int = parseInt(start_time.replace(':', '')) 
    let end_int = parseInt(end_time.replace(':', ''))
    if(start_time.includes('-') || end_time.includes('-'))
      return true 
    return start_time != end_time 
  }

  export function isCorrectTime(value){
    let time = value.replace(':', '')
    return !time.includes('-')
  }

